import logger from "redux-logger";

export const FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION =
  "FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION";
export const FETCH_CHEMISTINVOICEDETAILS_SUCCESS_ACTION =
  FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTINVOICEDETAILS_FAIL_ACTION =
  FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION =
  "FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION";
export const FETCH_CHEMISTINVOICESTATUSCHANGE_SUCCESS_ACTION =
  FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTINVOICESTATUSCHANGE_FAIL_ACTION =
  FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTINVOICESEARCH_INIT_ACTION =
  "FETCH_CHEMISTINVOICESEARCH_INIT_ACTION";
export const FETCH_CHEMISTINVOICESEARCH_SUCCESS_ACTION =
  FETCH_CHEMISTINVOICESEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTINVOICESEARCH_FAIL_ACTION =
  FETCH_CHEMISTINVOICESEARCH_INIT_ACTION + "_ERROR";

export const FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION =
  "FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION";
export const FILTER_BY_CHEMISTINVOICE_STATUS_SUCCESS_ACTION =
  FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION + "_SUCCESS";
export const FILTER_BY_CHEMISTINVOICE_STATUS_FAIL_ACTION =
  FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION + "_ERROR";

export function ChemistInvoiceList(value) {
  return {
    type: FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION,
    value:value,
  };
}
export function ChemistInvoiceSelectedPage(value) {
  return {
    type: FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION,
    value: value
  };
}
export function ChemistInvoiceStatusChange(value) {
  return {
    type: FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION,
    value: value
  };
}
export function ChemistInvoiceSearch(value) {
  return {
    type: FETCH_CHEMISTINVOICESEARCH_INIT_ACTION,
    value: value
  };
}
export function ChemistInvoiceSearchSelectedPage(value) {
  return {
    type: FETCH_CHEMISTINVOICESEARCH_INIT_ACTION,
    value: value
  };
}
export function FliterSearchChemistInvoice(value) {
  return {
    type: FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION,
    value: value
  };
}
export function fltrChemistInvoicePagetn(value) {
  return {
    type: FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION,
    value: value
  };
}
